import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/backend/pages/layout/Layout';
import Main from '@/backend/pages/layout/components/AppMain';
Vue.use(Router);

export const constantRouters = [
	{
		path: '/evaluate',
		name: 'evaluate',
		component: () => import('@/backend/pages/evaluate/home'),
	},
	{
		path: '/status',
		name: 'status',
		component: () => import('@/backend/pages/evaluate/status'),
	},
	{
		path: '/evaluates',
		name: 'evaluates',
		component: () => import('@/backend/pages/evaluate/evaluate'),
	},
	{
		path: '/audit',
		name: 'audit',
		component: () => import('@/backend/pages/audit/audit.vue'),
	},
	{
		path: '/401',
		name: 'Err401',
		hidden: true,
		component: () => import('@/backend/pages/errorPage/401'),
	},
	{
		path: '/404',
		name: '404',
		hidden: true,
		component: () => import('@/backend/pages/errorPage/404'),
	},
	{
		path: '/',
		redirect: '/customerinfo/customer',
	},
	{
		path: '*',
		redirect: '/404',
	},
];

export const asyncRouters = [
	{
		path: '/customerinfo',
		name: 'customerinfo',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '客户信息',
			icon: 'kehuxinxi',
			isValid: true,
		},
		redirect: '/customerinfo/customer',
		children: [
			{
				path: 'customer',
				name: 'customer',
				component: () => import('@/backend/pages/customerinfo/customer.vue'),
				meta: {
					title: '客户列表',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'customerDetail',
				name: 'customerConfig',
				hideNav: true,
				component: Main,
				redirect: '/customerinfo/customer',
				meta: {
					title: '客户列表',
					isValid: true,
				},
				children: [
					{
						path: '/customerinfo/customer/customerDetail',
						name: 'customerDetail',
						hideNav: true,
						component: () => import('@/backend/pages/customerinfo/customerDetail.vue'),
						meta: {
							title: '客户详情',
						},
					},
				],
			},
			{
				path: 'customerDetai2',
				name: 'customerConfig2',
				hideNav: true,
				component: Main,
				redirect: '/customerinfo/customer',
				meta: {
					title: '客户列表',
				},
				children: [
					{
						path: '/customerinfo/customerAccount',
						name: 'customerAccount',
						hideNav: true,
						component: () => import('@/backend/pages/customerinfo/customerAccount.vue'),
						meta: {
							title: '客户账号管理',
						},
					},
				],
			},
		],
	},
	{
		path: '/task',
		name: 'task',
		component: Layout,
		redirect: '/task/taskBoard',
		alwaysShow: true,
		meta: {
			title: '任务管理',
			icon: 'renwu',
			isValid: true,
		},
		children: [
			{
				path: 'taskBoard',
				name: 'taskBoard',
				component: () => import('@/backend/pages/task/taskBan.vue'),
				meta: {
					title: '任务看板',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'taskList',
				name: 'taskList',
				component: () => import('@/backend/pages/task/taskList.vue'),
				meta: {
					title: '任务列表',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'taskReport',
				name: 'taskReport',
				component: () => import('@/backend/pages/taskStatistics/taskReport.vue'),
				meta: {
					title: '任务统计',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'taskLists',
				name: 'taskLists',
				redirect: '/task/taskList',
				hideNav: true,
				component: Main,
				hidden: true,
				meta: {
					title: '任务列表',
				},
				children: [
					{
						path: '/task/taskDetail',
						name: 'taskDetail',
						component: () => import('@/backend/pages/task/taskDetail.vue'),
						hideNav: true,
						meta: {
							title: '任务详情',
						},
					},
					{
						path: '/task/taskSubDetail',
						name: 'taskSubDetail',
						component: () => import('@/backend/pages/task/taskDetail.vue'),
						hideNav: true,
						meta: {
							title: '子任务详情',
						},
					},
				],
			},
		],
	},
	{
		path: '/socialMedia',
		component: Layout,
		redirect: '/socialMedia/account',
		name: 'socialMedia',
		alwaysShow: true,
		meta: {
			title: '社媒管理',
			icon: 'shemeiguanli',
			isValid: true,
		},
		children: [
			{
				path: 'account',
				name: 'socialMedialAccount',
				component: () => import('@/backend/pages/socialMedia/account.vue'),
				meta: {
					title: '社媒账号',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'account',
				name: 'account',
				hideNav: true,
				component: Main,
				redirect: '/socialMedia/account',
				meta: {
					title: '社媒账号',
					isValid: true,
				},
				children: [
					{
						path: '/socialMedia/account/autoResponse',
						name: 'autoResponse',
						component: () => import('@/backend/pages/socialMedia/autoResponse.vue'),
						meta: {
							title: '自动回复设置',
							cache: true,
							isValid: true,
						},
					},
				],
			},

			{
				path: 'tweets',
				name: 'socialMedialTweets',
				meta: {
					title: '推文管理',
					cache: true,
					isValid: true,
				},
				component: () => import('@/backend/pages/socialMedia/tweets.vue'),
			},
			{
				path: 'chat',
				name: 'chat',
				meta: {
					title: '即时聊天',
					cache: true,
					isValid: true,
				},
				component: () => import('@/backend/pages/socialMedia/chat.vue'),
			},
			{
				path: 'chatSet',
				name: 'chatSet',
				component: () => import('@/backend/pages/socialMedia/chatSet.vue'),
				meta: {
					title: '即时聊天配置',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'chatSet',
				name: 'chatSet1',
				redirect: '/socialMedia/chatSet',
				hideNav: true,
				component: Main,
				meta: {
					title: '即时聊天配置',
					cache: true,
				},
				children: [
					{
						path: 'configPage',
						name: 'configPage',
						component: () => import('@/backend/pages/socialMedia/configPage.vue'),
						hideNav: true,
						meta: {
							title: '配置页面',
						},
					},
				],
			},
			{
				path: 'auth',
				name: 'socialMedialAuth',
				hideNav: true,
				meta: {
					title: '授权管理',
					cache: true,
					isValid: true,
				},
				component: () => import('@/backend/pages/socialMedia/auth.vue'),
			},
		],
	},
	{
		path: '/enquiryList',
		name: 'enquiryList',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '询盘',
			icon: 'xunpan',
			isValid: true,
		},
		redirect: '/enquiryList/enquiry',
		children: [
			{
				path: 'enquiry',
				name: 'enquiry',
				alwaysShow: true,
				component: () => import('@/backend/pages/enquiryList/enquiry.vue'),
				meta: {
					title: '询盘列表',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'enquirys',
				name: 'enquirys',
				hideNav: true,
				component: Main,
				redirect: '/enquiryList/enquiry',
				meta: {
					title: '询盘列表',
					isValid: true,
				},
				children: [
					{
						path: '/enquiryList/enquiry_detail',
						name: 'enquiry_detail',
						hideNav: true,
						component: () => import('@/backend/pages/enquiryList/enquiry_detail.vue'),
						meta: {
							title: '询盘详请',
						},
					},
				],
			},
			{
				path: 'enquiryStatistic',
				name: 'enquiryStatistic',
				component: () => import('@/backend/pages/enquiryList/enquiry_statistics.vue'),
				meta: {
					title: '询盘统计',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'enquiryStatistic',
				name: 'enquiryStatistics',
				hideNav: true,
				component: Main,
				redirect: '/enquiryList/enquiryStatistic',
				meta: {
					title: '询盘统计',
				},
				children: [
					{
						path: '/enquiry/enquiryStatistics/enquiryStatisticsDetail',
						name: 'enquiryStatisticsDetail',
						hideNav: true,
						component: () => import('@/backend/pages/enquiryList/enquiry_statistics.vue'),
						meta: {
							title: '询盘统计详情',
						},
					},
				],
			},
		],
	},
	{
		path: '/website',
		name: 'website',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '客户数据',
			icon: 'wangjian',
			isValid: true,
		},
		redirect: '/website/websiteList',
		children: [
			{
				path: 'websiteList',
				name: 'websiteList',
				alwaysShow: true,
				component: () => import('@/backend/pages/website/websiteList.vue'),
				meta: {
					title: '网站管理',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'websiteList',
				name: 'websiteLists',
				hideNav: true,
				component: Main,
				redirect: '/website/websiteList',
				meta: {
					title: '网站管理',
					isValid: true,
				},
				children: [
					{
						path: 'website_detail',
						name: 'website_detail',
						hideNav: true,
						component: () => import('@/backend/pages/website/website_detail.vue'),
						meta: {
							title: '网建详请',
						},
					},
					{
						path: 'MonitoringBinding',
						name: 'MonitoringBinding',
						hideNav: true,
						component: () => import('@/backend/pages/website/MonitoringBinding.vue'),
						meta: {
							title: '监测绑定',
						},
					},
				],
			},
			{
				path: 'website_report',
				name: 'website_report',
				component: () => import('@/backend/pages/website/website_report.vue'),
				meta: {
					title: '网站数据',
					isValid: true,
				},
			},
			{
				path: 'googlereport',
				name: 'googleReport',
				component: () => import('@/backend/pages/website/googlereport.vue'),
				meta: {
					title: '广告报告',
					isValid: true,
					cache: true,
				},
			},
			{
				path: 'reportToDownload',
				name: 'reportToDownload',
				component: () => import('@/backend/pages/website/reportToDownload.vue'),
				meta: {
					title: '报告下载',
					isValid: true,
					cache: true,
				},
			},
			{
				path: 'reportToDownload1',
				name: 'reportToDownload1',
				hideNav: true,
				redirect: '/website/reportToDownload',
				component: Main,
				meta: {
					title: '报告下载',
				},
				children: [
					{
						path: 'templateManagement',
						name: 'templateManagement',
						component: () => import('@/backend/pages/website/templateManagement.vue'),
						meta: {
							title: '模板管理',
							cache: true,
						},
					},
					{
						path: 'templateManagement1',
						name: 'templateManagement1',
						redirect: '/website/reportToDownload1/templateManagement',
						component: Main,
						meta: {
							title: '模板管理',
						},
						children: [
							{
								path: 'templateEditor',
								name: 'templateEditor',
								component: () => import('@/components/website/templateManage/templateEditor.vue'),
								meta: {
									title: '模板编辑',
									// cache: true,
								},
							},
						],
					},
					{
						path: 'reportPreviewSuggestions',
						name: 'reportPreviewSuggestions',
						component: () => import('@/backend/pages/website/reportPreviewSuggestions.vue'),
						meta: {
							title: '预览&建议',
						},
					},
					{
						path: 'balanceMatching',
						name: 'balanceMatching',
						component: () => import('@/backend/pages/website/balanceMatching.vue'),
						meta: {
							title: '余额匹配',
							isValid: true,
						},
					},
				],
			},
			{
				path: 'searchTermReport',
				name: 'searchTermReport',
				component: () => import('@/backend/pages/website/searchTermReport.vue'),
				meta: {
					title: '搜索词报告',
					isValid: true,
					cache: true,
				},
			},
			{
				path: 'facebookreport',
				name: 'facebookReport',
				component: () => import('@/backend/pages/website/facebookReport.vue'),
				meta: {
					title: 'Facebook Ads报告',
					isValid: true,
					// cache: true,
				},
			},
			{
				path: 'facebookreport1',
				name: 'facebookReport1',
				hideNav: true,
				redirect: '/website/facebookreport',
				component: Main,
				meta: {
					title: 'Facebook Ads报告',
				},
				children: [
					{
						path: 'facebookDetails',
						name: 'facebookDetails',
						component: () => import('@/backend/pages/website/facebookDetails.vue'),
						meta: {
							title: '受众报告',
						},
					},
				],
			},
			{
				path: 'resultsReport',
				name: 'resultsReport',
				component: () => import('@/backend/pages/website/resultsReport.vue'),
				meta: {
					title: '成效报告',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'resultsReport',
				name: 'resultsReports',
				hideNav: true,
				component: Main,
				redirect: '/website/resultsReport',
				meta: {
					title: '成效报告',
					isValid: true,
					cache: true,
				},
				children: [
					{
						path: '/website/resultsReport/reportDetail',
						name: 'reportDetail',
						hideNav: true,
						component: () => import('@/backend/pages/website/reportDetail.vue'),
						meta: {
							title: '报告详情',
						},
					},
				],
			},
			{
				path: 'Searchtermreport',
				name: 'Searchtermreport',
				hideNav: true,
				component: Main,
				redirect: '/website/searchTermReport',
				meta: {
					title: '搜索词报告',
					isValid: true,
					cache: true,
				},
				children: [
					{
						path: '/website/googlereport/customerSubmission',
						name: 'customerSubmission',
						hideNav: true,
						component: () => import('@/backend/pages/website/customerSubmission.vue'),
						meta: {
							title: '客户提交',
							cache: true,
						},
					},
				],
			},
			{
				path: 'visitorDiscern',
				name: 'visitorDiscern',
				component: () => import('@/backend/pages/setting/visitorDiscern.vue'),
				meta: {
					title: '网站访客识别',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'visitorDiscern1',
				name: 'visitorDiscern1',
				component: Main,
				hideNav: true,
				redirect: '/website/visitorDiscern',
				meta: {
					title: '网站访客识别',
					cache: true,
				},
				children: [
					{
						path: 'visitorDetails',
						name: 'visitorDetails',
						component: () => import('@/backend/pages/setting/visitorDetails.vue'),
						meta: {
							title: '访客详情',
						},
					},
				],
			},
			{
				path: 'flowAnalysis',
				name: 'flowAnalysis',
				component: () => import('@/backend/pages/flowAnalysis/flowAnalysis.vue'),
				meta: {
					title: '自然流量',
					// cache: true,
					isValid: true,
				},
			},
			{
				path: 'myWebsiteMonitor',
				name: 'myWebsiteMonitor',
				component: () => import('@/backend/pages/website_monitor/myWebsiteMonitor.vue'),
				meta: {
					title: '网站报告',
					isValid: true,
				},
			},
			{
				path: 'webSiteIndexData',
				name: 'webSiteIndexData',
				component: () => import('@/backend/pages/webSiteIndexData/webSiteIndexData.vue'),
				meta: {
					title: '网站索引',
					isValid: true,
				},
			},
			{
				path: 'seoTakeDown',
				name: 'seoTakeDown',
				component: () => import('@/backend/pages/seoTakeDown/seoTakeDown.vue'),
				meta: {
					title: 'Site收录',
					isValid: true,
				},
			},
			{
				path: 'siteSeoAnalysis',
				name: 'siteSeoAnalysis',
				component: () => import('@/backend/pages/siteSeoAnalysis/siteSeoAnalysis.vue'),
				meta: {
					title: '站内SEO分析',
					isValid: true,
				},
			},
			{
				path: 'keywordRanking',
				name: 'keywordRanking',
				component: () => import('@/backend/pages/keywordRanking/keywordRanking.vue'),
				meta: {
					title: '关键字排名',
					isValid: true,
				},
			},
			{
				path: 'website_access_record',
				name: 'website_access_record',
				component: () => import('@/backend/pages/websiteAccessRecord/website_access_record.vue'),
				meta: {
					title: '网站访问记录',
					isValid: true,
				},
			},
		],
	},
	{
		path: '/setting',
		name: 'setting',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '设置',
			icon: 'shezhi',
			isValid: true,
		},
		redirect: '/setting/taskflow',
		children: [
			{
				path: 'taskflow',
				name: 'taskflow',
				component: () => import('@/backend/pages/setting/taskflowList.vue'),
				meta: {
					title: '任务流配置',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'taskflow',
				name: 'taskflows',
				hideNav: true,
				component: Main,
				redirect: '/setting/taskflow',
				meta: {
					title: '任务流配置',
					isValid: true,
				},
				children: [
					{
						path: '/setting/taskflow/taskflowConf',
						name: 'taskflowConf',
						hideNav: true,
						component: () => import('@/backend/pages/setting/taskflowConf.vue'),
						meta: {
							title: '任务流详情',
						},
					},
				],
			},
			{
				path: 'versionControl',
				name: 'versionControl',
				component: () => import('@/backend/pages/setting/versionControl.vue'),
				meta: {
					title: '客户端设置',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'versionControls',
				name: 'versionControls',
				hideNav: true,
				redirect: '/setting/versionControl',
				component: Main,
				meta: {
					title: '客户端设置',
					isValid: true,
				},
				children: [
					{
						path: '/setting/versionControl/addRole',
						name: 'addRole',
						component: () => import('@/backend/pages/setting/addRole.vue'),
						meta: {
							title: '编辑角色',
							cache: true,
						},
					},
				],
			},
			{
				path: 'saas',
				name: 'saas',
				component: () => import('@/backend/pages/setting/SaaS.vue'),
				meta: {
					title: '功能与套餐配置',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'saas',
				name: 'saas1',
				hideNav: true,
				component: Main,
				meta: {
					title: '功能与套餐配置',
					cache: true,
					isValid: true,
				},
				children: [
					{
						path: 'setMealConfig',
						name: 'setMealConfig',
						component: () => import('@/backend/pages/setting/SaaS/setMealConfig.vue'),
						meta: {
							title: '套餐配置',
							cache: true,
						},
					},
					{
						path: 'couponsConfig',
						name: 'couponsConfig',
						component: () => import('@/backend/pages/setting/SaaS/couponsConfig.vue'),
						meta: {
							title: '自动优惠券配置',
							cache: true,
						},
					},
					{
						path: 'renewalWhitelist',
						name: 'renewalWhitelist',
						component: () => import('@/backend/pages/setting/SaaS/renewalWhitelist.vue'),
						meta: {
							title: '续费白名单',
							cache: true,
						},
					},
				],
			},
			{
				path: 'couponControl',
				name: 'couponControl',
				component: () => import('@/backend/pages/setting/couponControl.vue'),
				meta: {
					title: '优惠券管理',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'garbageInquiryFilter',
				name: 'garbageInquiryFilter',
				component: () => import('@/backend/pages/setting/garbageInquiryFilter.vue'),
				meta: {
					title: '垃圾询盘过滤',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'garbageInquiryFilter',
				name: 'garbageInquiryFilters',
				hideNav: true,
				component: Main,
				redirect: '/setting/garbageInquiryFilter',
				meta: {
					title: '垃圾询盘过滤',
					isValid: true,
				},
				children: [
					{
						path: '/setting/garbageInquiryFilter/blacklist',
						name: 'blacklist',
						hideNav: true,
						component: () => import('@/backend/pages/setting/blacklist.vue'),
						meta: {
							title: '黑名单列表',
							cache: true,
						},
					},
					{
						path: '/setting/garbageInquiryFilter/whiteList',
						name: 'whiteList',
						hideNav: true,
						component: () => import('@/backend/pages/setting/whiteList.vue'),
						meta: {
							title: '白名单列表',
							cache: true,
						},
					},
				],
			},
			{
				path: 'functionUpdateDescription',
				name: 'functionUpdateDescription',
				component: () => import('@/backend/pages/setting/functionUpdateDescription.vue'),
				meta: {
					title: '功能更新说明',
					cache: true,
					// isValid: true,
				},
			},
			{
				path: 'emailHost',
				name: 'emailHost',
				component: () => import('@/backend/pages/setting/emailHost.vue'),
				meta: {
					title: '邮箱host配置',
					// cache: true,
					isValid: true,
				},
			},
			{
				path: 'welcomePage',
				name: 'welcomePage',
				component: () => import('@/backend/pages/welcomePage/welcomePage.vue'),
				meta: {
					title: '欢迎页配置',
					// cache: true,
					isValid: true,
				},
			},
		],
	},
	// 工单
	{
		path: '/workOrder',
		name: 'workOrder',
		alwaysShow: true,
		component: Layout,
		meta: {
			title: '工单管理',
			icon: 'order',
			isValid: true,
		},
		redirect: '/workOrder/workOrder',
		children: [
			{
				path: 'workOrder',
				name: 'workOrderSubmitted',
				component: () => import('@/backend/pages/workOrder/workOrder'),
				meta: {
					title: '我提交的工单',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'workOrderNeedTodo',
				name: 'workOrderNeedTodo',
				meta: {
					title: '需要我处理的工单',
					cache: true,
					isValid: true,
				},
				component: () => import('@/backend/pages/workOrder/workOrderNeedTodo.vue'),
			},
			{
				path: 'workOrderAll',
				name: 'workOrderAll',
				meta: {
					title: '全部工单',
					cache: true,
					isValid: true,
				},
				component: () => import('@/backend/pages/workOrder/workOrderAll.vue'),
			},
			{
				path: 'workOrder',
				name: 'workOrderSubmitteds',
				hideNav: true,
				component: Main,
				meta: {
					title: '我提交的工单',
					isValid: true,
				},
				children: [
					{
						path: '/workOrder/workOrderDetail',
						name: 'submitWorkOrderDetail',
						hideNav: true,
						component: () => import('@/backend/pages/workOrder/workOrderDetail'),
						meta: {
							title: '工单详情',
						},
					},
				],
			},
			{
				path: 'workOrderNeedTodo',
				name: 'workOrderNeedTodos',
				hideNav: true,
				component: Main,
				meta: {
					title: '需要我处理的工单',
					isValid: true,
				},
				children: [
					{
						path: '/workOrder/WorkOrderDetail',
						name: 'myWorkOrderDetail',
						hideNav: true,
						component: () => import('@/backend/pages/workOrder/workOrderDetail'),
						meta: {
							title: '工单详情',
						},
					},
				],
			},
			{
				path: 'workOrderAll',
				name: 'workOrderAlls',
				hideNav: true,
				component: Main,
				meta: {
					title: '全部工单',
					isValid: true,
				},
				children: [
					{
						path: '/workOrder/WorkOrderDetail',
						name: 'workOrderAllDetail',
						hideNav: true,
						component: () => import('@/backend/pages/workOrder/workOrderDetail'),
						meta: {
							title: '工单详情',
						},
					},
				],
			},
		],
	},
	{
		path: '/helpSeting',
		hidden: true,
		component: Layout,
		children: [
			{
				path: '/helpSeting',
				name: 'helpSeting',
				hidden: true,
				component: () => import('@/backend/pages/kit/helpSeting.vue'),
				meta: {
					title: '帮助中心',
				},
			},
		],
	},
	{
		path: '/kit',
		name: 'kit',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '工具',
			icon: 'gongju',
			isValid: true,
		},
		redirect: '/kit/seoBoard',
		children: [
			{
				path: 'seoBoard',
				name: 'seoBoard',
				alwaysShow: true,
				component: () => import('@/backend/pages/kit/seoBoard.vue'),
				meta: {
					title: 'SEO看板',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'seoBoards',
				name: 'seoBoards',
				hideNav: true,
				component: Main,
				redirect: '/kit/seoBoard',
				meta: {
					title: 'SEO看板',
					isValid: true,
				},
				children: [
					{
						path: '/kit/keywordPlanning',
						name: 'keywordPlanning',
						hideNav: true,
						component: () => import('@/backend/pages/kit/keywordPlanning.vue'),
						meta: {
							title: '关键词规划',
						},
					},
					{
						path: '/kit/articleDetail',
						name: 'articleDetail',
						hideNav: true,
						component: () => import('@/backend/pages/kit/articleDetail.vue'),
						meta: {
							title: '文章详情',
						},
					},
					{
						path: '/kit/articleAssistant',
						name: 'articleAssistant',
						hideNav: true,
						component: () => import('@/backend/pages/kit/articleAssistant.vue'),
						meta: {
							title: '文章助手',
						},
					},
				],
			},
			{
				path: 'kit',
				name: 'kitList',
				component: () => import('@/backend/pages/kit/kit.vue'),
				meta: {
					title: '工具箱',
				},
			},
			{
				path: 'kits',
				name: 'kitLists',
				hideNav: true,
				component: Main,
				meta: {
					title: '工具箱',
				},
				redirect: '/kit/kit',
				children: [
					{
						path: '/kitDetail',
						name: 'kitDetail',
						hidden: true,
						meta: {
							title: 'TDK检查',
						},
						component: () => import('@/backend/pages/kit/kitDetail.vue'),
					},
					{
						path: '/keywordAssistant',
						name: 'keywordAssistant',
						hidden: true,
						meta: {
							title: '市场洞察工具',
						},
						component: () => import('@/backend/pages/kit/keywordAssistant.vue'),
					},
					{
						path: '/industruReport',
						name: 'industruReport',
						hidden: true,
						meta: {
							title: '行业效果报告',
						},
						component: () => import('@/backend/pages/kit/industruReport.vue'),
					},
				],
			},
			{
				path: 'evaluation',
				name: 'evaluation',
				component: () => import('@/backend/pages/kit/customerEvaluation.vue'),
				meta: {
					title: '客户评价',
					isValid: true,
					cache: true,
				},
			},
			{
				path: 'keyWordReports',
				name: 'keyWordReports',
				component: () => import('@/backend/pages/kit/keyWordReport.vue'),
				meta: {
					title: '网站关键词报告',
					isValid: true,
					cache: true,
				},
			},
			{
				path: 'keyWordReports1',
				name: 'keyWordReports1',
				hideNav: true,
				component: Main,
				meta: {
					title: '网站关键词报告',
					isValid: true,
				},
				redirect: '/kit/keyWordReports',
				children: [
					{
						path: '/keyWordReportList',
						name: 'keyWordReportList',
						hidden: true,
						meta: {
							title: '网站关键词报告列表',
						},
						component: () => import('@/backend/pages/kit/keyWordReportList.vue'),
					},
				],
			},
		],
	},
	{
		path: '/googleAds',
		name: 'googleAds',
		component: Layout,
		alwaysShow: true,
		meta: {
			title: '投放效果',
			icon: 'xunpan',
			isValid: true,
		},
		redirect: '/googleAds/AdsMonitoringList',
		children: [
			{
				path: 'AdsMonitoringList',
				name: 'AdsMonitoringList',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/AdsMonitoringList.vue'),
				meta: {
					title: 'Ads监测列表',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'warningList',
				name: 'warningList',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/warningList.vue'),
				meta: {
					title: '预警列表',
					cache: true,
					isValid: true,
				},
			},
			// {
			// 	path: 'newUserOnline',
			// 	name: 'newUserOnline',
			// 	alwaysShow: true,
			// 	component: () => import('@/backend/pages/googleAds/newUserOnline.vue'),
			// 	meta: {
			// 		title: '新用户上线方案',
			// 		cache: true,
			// 		isValid: true,
			// 	},
			// },
			// {
			// 	path: 'adsOnlineAutoList',
			// 	name: 'adsOnlineAutoList',
			// 	alwaysShow: true,
			// 	component: () => import('@/backend/pages/googleAds/adsOnlineAutoList.vue'),
			// 	meta: {
			// 		title: '新户自动化上线',
			// 		cache: true,
			// 		isValid: true,
			// 	},
			// },
			{
				path: 'adsTabPage',
				name: 'adsTabPage',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/adsTabPage.vue'),
				meta: {
					title: '新户自动化上线',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'adsTabPage',
				name: 'adsTabPage',
				hideNav: true,
				component: Main,
				redirect: '/googleAds/adsTabPage',
				meta: {
					title: '新户自动化上线',
				},
				children: [
					{
						path: 'accountOnline',
						name: 'accountOnline',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/components/accountOnline.vue'),
						meta: {
							title: '账户上线',
						},
					},
					{
						path: 'adsSkeleton',
						name: 'adsSkeleton',
						hideNav: true,
						component: () => import('@/components/adsOnlineAuto/ads-skeleton.vue'),
						meta: {
							title: '开始填写初始方案',
						},
					},
					{
						path: 'launchPlan',
						name: 'launchPlan',
						hideNav: true,
						component: () => import('@/components/adsOnlineAuto/mainPages/launchPlan.vue'),
						meta: {
							title: '查看方案',
						},
					},
					{
						path: 'adsSkeleton',
						name: 'showAdsSkeleton',
						hideNav: true,
						component: () => import('@/components/adsOnlineAuto/ads-skeleton.vue'),
						meta: {
							title: '查看方案',
						},
					},
					{
						path: 'detailsAboutNewUser',
						name: 'detailsAboutNewUser',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/components/detailsAboutNewUser.vue'),
						meta: {
							title: '新用户上线详情',
						},
					},
				],
			},
			{
				path: 'adsAccountManagement',
				name: 'adsAccountManagement',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/adsAccountManagement.vue'),
				meta: {
					title: 'Ads账户管理',
					isValid: true,
				},
			},
			{
				path: 'adsAccountManagement',
				name: 'adsAccountManagement1',
				hideNav: true,
				component: Main,
				redirect: '/googleAds/adsAccountManagement',
				meta: {
					title: 'Ads账户管理',
				},
				children: [
					{
						path: 'accountManagement',
						name: 'accountManagement',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/accountManagement.vue'),
						meta: {
							title: '账户管理',
						},
					},
					{
						path: 'accountDetection',
						name: 'accountDetection',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/accountDetection.vue'),
						meta: {
							title: '账号检测',
						},
					},
					{
						path: '/googleAds/adsAccountManagement/addAdSeries',
						name: 'addAdSeries',
						component: () => import('@/backend/pages/googleAds/addAdSeries.vue'),
						meta: {
							title: '新建广告系列',
						},
					},
					{
						path: '/googleAds/adsAccountManagement/addAdGroup',
						name: 'addAdGroup',
						component: () => import('@/backend/pages/googleAds/addAdGroup.vue'),
						meta: {
							title: '新建广告组',
						},
					},
					{
						path: '/googleAds/adsAccountManagement/addAdVertising',
						name: 'addAdVertising',
						component: () => import('@/backend/pages/googleAds/addAdVertising.vue'),
						meta: {
							title: '新建广告',
						},
					},
					{
						path: '/googleAds/adsAccountManagement/addAdKeyword',
						name: 'addAdKeyword',
						component: () => import('@/backend/pages/googleAds/addAdKeyword.vue'),
						meta: {
							title: '新建关键词',
						},
					},
				],
			},
			{
				path: 'extensionTermManagement',
				name: 'extensionTermManagement',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/extensionTermManagement.vue'),
				meta: {
					title: '拓词管理',
					cache: true,
					isValid: true,
				},
			},
			// {
			// 	path: 'newUserOnline',
			// 	name: 'newUserOnline',
			// 	hideNav: true,
			// 	component: Main,
			// 	redirect: '/googleAds/newUserOnline',
			// 	meta: {
			// 		title: '新用户上线方案',
			// 	},
			// 	children: [
			// 		{
			// 			path: 'detailsAboutNewUser',
			// 			name: 'detailsAboutNewUser',
			// 			hideNav: true,
			// 			component: () => import('@/backend/pages/googleAds/components/detailsAboutNewUser.vue'),
			// 			meta: {
			// 				title: '新用户上线详情',
			// 			},
			// 		},
			// 	],
			// },
			{
				path: 'targetCustomerMatching',
				name: 'targetCustomerMatching',
				alwaysShow: true,
				component: () => import('@/backend/pages/googleAds/targetCustomerMatching.vue'),
				meta: {
					title: '目标客户匹配',
					cache: true,
					isValid: true,
				},
			},
			{
				path: 'targetCustomerMatching',
				name: 'targetCustomerMatching',
				hideNav: true,
				component: Main,
				redirect: '/googleAds/targetCustomerMatching',
				meta: {
					title: '目标客户匹配',
				},
				children: [
					{
						path: 'industryPackageDetails',
						name: 'industryPackageDetails',
						hideNav: true,
						component: () =>
							import('@/backend/pages/googleAds/components/industryPackageDetails.vue'),
						meta: {
							title: '行业包详情',
						},
					},
				],
			},
			{
				path: 'warningList',
				name: 'warningList1',
				hideNav: true,
				component: Main,
				redirect: '/googleAds/warningList',
				meta: {
					title: '预警列表',
				},
				children: [
					{
						path: '/googleAds/warningLog',
						name: 'warningLog',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/warningListLog.vue'),
						meta: {
							title: '预警日志',
						},
					},
				],
			},

			{
				path: 'AdsMonitoringList',
				name: 'AdsMonitoringList1',
				hideNav: true,
				component: Main,
				redirect: '/googleAds/AdsMonitoringList',
				meta: {
					title: 'Ads监测列表',
				},
				children: [
					{
						path: '/googleAds/serviceDefault',
						name: 'serviceDefault',
						hideNav: true,
						component: () => import('@/backend/pages/googleAds/serviceDefault.vue'),
						meta: {
							title: '服务详情',
							cache: true,
						},
					},
				],
			},
		],
	},
];

// 避免冗余导航
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0,
	}),
	routes: constantRouters,
});
